module.exports = __webpack_public_path__ + "static/media/sh.6560d76b.svg";